import { Select } from "@/components/ui/select";

/**
 * The choice of section an item goes to the end of, named after the item: an unplaced figure
 * or claim, or a removed line whose section is gone.
 */
export function PlaceIn({
  words,
  sections,
  onPlace,
}: {
  /** How the item reads: "FIG. 3", "Claim 7", a line's words. */
  words: string;
  sections: { id: string; title: string }[];
  onPlace: (sectionId: string) => void;
}) {
  return (
    <Select
      size="dense"
      aria-label={`Place ${words} in`}
      value=""
      className="w-auto"
      onChange={(event) => {
        if (event.target.value !== "") onPlace(event.target.value);
      }}
    >
      <option value="">Place in…</option>
      {sections.map((section) => (
        <option key={section.id} value={section.id}>
          {section.title}
        </option>
      ))}
    </Select>
  );
}
